import React from "react";
import { Mail, MessageCircle } from "lucide-react";
import { useSidebar } from '../SidebarContext';

const HelpAndSupport = () => {
    const { isSidebarOpen } = useSidebar();

    return (
        <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
            <div>
                <div className="w-full bg-white shadow-xl rounded-2xl p-8 mt-5">
                    <h1 className="text-2xl font-bold text-[#1e3a8a] text-center">
                        Help & Support
                    </h1>
                    <p className="text-center text-gray-600 mb-7">
                        We're here to assist you. Reach out to us via WhatsApp or Email.
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* WhatsApp Card */}
                        <div className="border rounded-xl p-6 bg-[#e6fef0] border-green-500 shadow-md hover:shadow-lg transition-all">
                            <div className="flex items-center space-x-4">
                                <div className="bg-green-500 text-white p-3 rounded-full">
                                    <MessageCircle size={24} />
                                </div>
                                <div>
                                    <h2 className="text-xl font-semibold text-green-700">
                                        WhatsApp Support
                                    </h2>
                                    <p className="text-sm text-gray-600">Get instant help on chat.</p>
                                </div>
                            </div>
                            <a
                                href="https://wa.me/918433803555"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mt-4 inline-block text-white bg-green-500 hover:bg-green-600 transition px-4 py-2 rounded-lg font-medium"
                            >
                                Chat on WhatsApp
                            </a>
                        </div>

                        {/* Email Card */}
                        <div className="border rounded-xl p-6 bg-[#e6edff] border-blue-500 shadow-md hover:shadow-lg transition-all">
                            <div className="flex items-center space-x-4">
                                <div className="bg-blue-500 text-white p-3 rounded-full">
                                    <Mail size={24} />
                                </div>
                                <div>
                                    <h2 className="text-xl font-semibold text-blue-700">
                                        Email Support
                                    </h2>
                                    <p className="text-sm text-gray-600">We'll respond within 24 hrs.</p>
                                </div>
                            </div>
                            <a
                                href="mailto:support@100billiontech.com"
                                className="mt-4 inline-block text-white bg-blue-500 hover:bg-blue-600 transition px-4 py-2 rounded-lg font-medium"
                            >
                                Send an Email
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HelpAndSupport;
